<template>
  <div class="p_r" v-runshow>
    <img
      class="bg p_r"
      :src="require('@/assets/IntelligentPhysical/bg.png')"
      alt=""
    />
    <div class="ctx p_a">
      <div class="title">客户案例</div>
      <div class="tips"></div>

      <!-- PC端：无缝横向滚动 -->
      <div class="scroll-wrapper pc_">
        <div class="scroll-track">
          <div
            class="item_"
            v-for="(item, index) in list"
            :key="'a_' + index"
          >
            <img :src="item.src" alt="" />
          </div>
          <!-- 复制一份实现无缝衔接 -->
          <div
            class="item_"
            v-for="(item, index) in list"
            :key="'b_' + index"
          >
            <img :src="item.src" alt="" />
          </div>
        </div>
      </div>

      <!-- 移动端：swiper -->
      <div class="">
        <div class="mobile_">
          <div class="block">
            <div
              v-runcentershow
              class="ii_swiper swiper"
              style="height: calc(36vw + 20px)"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  style="width: 100vw"
                  v-for="(itemMain, indexMain) in listMiddle"
                  :key="indexMain"
                >
                  <div class="flex a_i_c j_c_a">
                    <div
                      v-for="(item, index) in itemMain"
                      :key="index"
                      class="mobile_item_"
                    >
                      <img :src="item.src" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="ii_swiper-pagination swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    var mySwiper = new Swiper(".ii_swiper", {
      direction: "horizontal",
      loop: true,
      pagination: {
        el: ".ii_swiper-pagination",
      },
    });
  },
  data() {
    return {
      list: [
        { src: require("@/assets/IntelligentPhysical/pic1.png") },
        { src: require("@/assets/IntelligentPhysical/pic2.png") },
        { src: require("@/assets/IntelligentPhysical/pic3.png") },
        { src: require("@/assets/IntelligentPhysical/pic4.png") },
        { src: require("@/assets/IntelligentPhysical/pic5.png") },
        { src: require("@/assets/IntelligentPhysical/pic6.png") },
        { src: require("@/assets/IntelligentPhysical/pic7.png") },
        { src: require("@/assets/IntelligentPhysical/pic8.png") },
        { src: require("@/assets/IntelligentPhysical/pic9.png") },
        { src: require("@/assets/IntelligentPhysical/pic10.png") },
        { src: require("@/assets/IntelligentPhysical/pic11.png") },
        { src: require("@/assets/IntelligentPhysical/pic12.png") },
        { src: require("@/assets/IntelligentPhysical/pic13.png") },
        { src: require("@/assets/IntelligentPhysical/pic14.png") },
        { src: require("@/assets/IntelligentPhysical/pic15.png") },
        { src: require("@/assets/IntelligentPhysical/pic16.png") },
        { src: require("@/assets/IntelligentPhysical/pic17.png") },
      ],
      listMiddle: [
        [
          { src: require("@/assets/IntelligentPhysical/pic1.png") },
          { src: require("@/assets/IntelligentPhysical/pic2.png") },
        ],
        [
          { src: require("@/assets/IntelligentPhysical/pic3.png") },
          { src: require("@/assets/IntelligentPhysical/pic4.png") },
        ],
        [
          { src: require("@/assets/IntelligentPhysical/pic5.png") },
          { src: require("@/assets/IntelligentPhysical/pic6.png") },
        ],
        [
          { src: require("@/assets/IntelligentPhysical/pic7.png") },
          { src: require("@/assets/IntelligentPhysical/pic8.png") },
        ],
        [
          { src: require("@/assets/IntelligentPhysical/pic9.png") },
          { src: require("@/assets/IntelligentPhysical/pic10.png") },
        ],
        [
          { src: require("@/assets/IntelligentPhysical/pic11.png") },
          { src: require("@/assets/IntelligentPhysical/pic12.png") },
        ],
        [
          { src: require("@/assets/IntelligentPhysical/pic13.png") },
          { src: require("@/assets/IntelligentPhysical/pic14.png") },
        ],
        [
          { src: require("@/assets/IntelligentPhysical/pic15.png") },
          { src: require("@/assets/IntelligentPhysical/pic16.png") },
        ],
        [{ src: require("@/assets/IntelligentPhysical/pic17.png") }],
      ],
    };
  },
};
</script>

<style scoped>
/* ==================== PC端无缝滚动 ==================== */
.scroll-wrapper {
  overflow: hidden;
  width: 100%;
  padding-top: 20px;
  margin-top: 60px;
}

.scroll-track {
  display: flex;
  gap: 20px;
  width: max-content;
  animation: scroll 30s linear infinite;
}

/* 鼠标放在滚动区域上时暂停 */
.scroll-wrapper:hover .scroll-track {
  animation-play-state: paused;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.item_ {
  width: 200px;
  flex-shrink: 0;
  transition: transform 0.5s;
}

.item_ > img {
  width: 100%;
  display: block;
}

/* 鼠标悬停单张图片：向上移动 */
.item_:hover {
  transform: translateY(-10px) !important;
}

/* ==================== 移动端 ==================== */
.mobile_item_ {
  width: 36vw;
  background: #fff;
  margin-top: 10px;
}
.mobile_item_ > img {
  width: 100%;
}

.title {
  font-size: 20px;
}
.bg {
  z-index: 1;
  background: #051436;
  width: 100%;
  height: 6.29rem;
  object-fit: cover;
  vertical-align: top;
}
.ctx {
  box-sizing: border-box;
  padding: 1.2rem 1.9rem;
  text-align: center;
  color: #fff;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
}
.tips {
  margin: 20px auto;
  width: 100px;
  height: 2px;
  background: #1aa858;
  margin-bottom: 4vw;
}
.mobile_ {
  height: 0 !important;
  overflow: hidden;
}
.mobile_ >>> .swiper-pagination-bullet {
  background: #fff !important;
}
.mobile_ >>> .swiper-pagination-bullet-active {
  background: #1aa858 !important;
}

@media screen and (max-width: 1024px) {
  .pc_ {
    display: none;
  }
  .mobile_ {
    height: auto !important;
    overflow: visible;
  }
  .bg {
    height: 6.81rem;
    object-fit: cover;
    vertical-align: top;
  }
  .ctx {
    padding: 0.96rem 20px;
  }
  .ctx .title {
    font-size: 0.48rem;
    line-height: 0.67rem;
    text-align: center;
  }
  .mobile_ {
    margin-top: 0.96rem;
  }
}
</style>